import request from "./client";

export type TenantUserRecord = {
  id: number;
  tenant_id: number;
  email: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  first_name: string;
  last_name: string;
  phone?: string | null;
  document_count?: number;
  pending_document_count?: number;
};

export async function getTenantUsers(token: string) {
  return request<TenantUserRecord[]>("/api/tenant-users", {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function getTenantUser(token: string, id: number) {
  return request<TenantUserRecord>(`/api/tenant-users/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function createTenantUser(
  token: string,
  payload: { tenant_id: number; email: string; password: string },
) {
  return request<TenantUserRecord>("/api/tenant-users", {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify(payload),
  });
}

export async function updateTenantUser(
  token: string,
  id: number,
  payload: { email?: string; is_active?: boolean; password?: string },
) {
  return request<TenantUserRecord>(`/api/tenant-users/${id}`, {
    method: "PATCH",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify(payload),
  });
}

export async function deleteTenantUser(token: string, id: number) {
  return request<{ success: boolean }>(`/api/tenant-users/${id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function resetTenantUserPassword(
  token: string,
  id: number,
  password: string,
) {
  return request<{ success: boolean }>(
    `/api/tenant-users/${id}/reset-password`,
    {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify({ password }),
    },
  );
}
